import React from "react"
import { makeStyles } from "@material-ui/styles"
import Img from "gatsby-image"
import withWidth, { isWidthUp } from "@material-ui/core/withWidth"

const useStyles = makeStyles(theme => {
  return {
    root: props => ({
      height: 640,
      position: "relative",
      zIndex: 0,
    }),

    imageWrapper: {
      alignItems: "stretch",
      position: "relative",
      height: 640,
      "& img": {
        objectFit: "cover",
      },
      "& video": {
        objectFit: "cover",
      },
      [theme.breakpoints.between("sm", "md")]: {
        position: "relative",
        height: theme.spacing(65),
        width: "100%",
      },
      [theme.breakpoints.down("sm")]: {
        position: "relative",
        height: theme.spacing(35),
        width: "100%",
      },
    },
    productLineBanner: {
      marginLeft: "100px",
      alignItems: "stretch",
      display: "flex",
      height: "100%",
      "& img": {
        objectFit: "cover",
      },
      [theme.breakpoints.down("md")]: {
        position: "relative",
        height: theme.spacing(35),
        width: "100%",
      },
    },
    image: {
      height: "100%",
      objectFit: "cover",
      width: "100%",
    },
  }
})

function HalfSizeHeroBannerMedia(props) {
  const classes = useStyles(props)
  return (
    <div className={classes.root}>
      <div
        className={
          props.isProductLine ? classes.productLineBanner : classes.imageWrapper
        }
      >
        {props.mediaType === "Video" && (
          <video
            src={props.videoSrc}
            width="100%"
            height="100%"
            preload="auto"
            loop
            controls={isWidthUp("md", props.width) ? false : true}
            autoPlay
            muted
          />
        )}
        {props.mediaType === "Image" &&
          (!props.productPage ? (
            <Img className={classes.image} fluid={props.imageSrc} alt={""} />
          ) : (
            <img src={props.imageSrc} alt={""} />
          ))}
      </div>
    </div>
  )
}

export default withWidth()(HalfSizeHeroBannerMedia)
